import React, { useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import PageRoutes from './routes/PageRoutes';
import 'bootstrap/dist/css/bootstrap.min.css';
import { registerServiceWorker } from "./serviceWorkerRegistration";
import { requestNotificationPermission } from "./firebase"
function App() {
  useEffect(() => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(requestNotificationPermission);
    } else {
      setTimeout(requestNotificationPermission, 3000);
    }
  }, [])

  useEffect(() => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(registerServiceWorker);
    } else {
      setTimeout(registerServiceWorker, 3000);
    }
  }, []);

  return (
    <PageRoutes />
  );
}

export default App;
